import React, { useCallback } from 'react';
import styles from '../index.less';

const TicketRate = ({
  onChange,
  value,
  disabled = false,
  evaluateItemList,
  className,
  size = '',
}) => {
  // console.log('evalueteItem', evaluateItemList);
  const handleStarChange = useCallback(
    item => {
      if (disabled) return;
      if (onChange) onChange(item);
    },
    [disabled, onChange]
  );

  return (
    <div className={`${styles.rateWrapper} ${className} ${styles[size]}`}>
      <ul className={styles.starList}>
        {evaluateItemList?.map(item => (
          <li
            key={item.value}
            className={`${styles.starItem} ${value >= item.value ? styles.active : ''} ${
              disabled ? styles.disabled : ''
            }`}
            onClick={() => handleStarChange(item)}
          />
        ))}
      </ul>
    </div>
  );
};
export default TicketRate;
